{
  "title": "Hesab",
  "registerTitle": "Qeydiyyat",
  "subtitle": "E-poçt, Google, telefon və ya Telegram ilə daxil olun - bütün üsullar eyni hesab və balansa aparır.",
  "email": "E-poçt",
  "password": "Şifrə",
  "showPassword": "Göstər",
  "hidePassword": "Gizlət",
  "acceptTerms": "İstifadə qaydalarını qəbul edirəm",
  "registerCta": "Qeydiyyatdan keç",
  "haveAccount": "Artıq hesabım var?",
  "needAccount": "Hesabınız yoxdur?",
  "telegramHint": "Telegram Mini App-də avtomatik giriş aktivdir (initData serverdə yoxlanır).",
  "unavailable": "Autentifikasiya hələ aktiv deyil",
  "telegramSoon": "Telegram ilə giriş tezliklə",
  "webSoon": "Veb giriş tezliklə",
  "googleDisabled": "Google girişi OAuth konfiqurasiya olunana qədər deaktivdir",
  "googleReady": "Google ilə davam et",
  "smsDisabled": "SMS girişi provayder konfiqurasiya olunana qədər deaktivdir",
  "smsReady": "Telefon ilə davam et",
  "orEmail": "E-poçt",
  "registerShort": "Qeydiyyat",
  "loginTitle": "Daxil ol",
  "tabEmail": "E-poçt",
  "tabPhone": "Telefon",
  "emailPlaceholder": "E-mail",
  "phoneUnavailableTitle": "Telefonla giriş hələ aktiv deyil",
  "phoneUnavailableBody": "SMS xidməti qoşulmayıb. E-poçt və şifrə ilə davam edin.",
  "phonePlaceholder": "50 123 45 67",
  "phoneInvalidAz": "Azərbaycan mobil nömrəsi 9 rəqəm olmalıdır (məs. 50 123 45 67).",
  "casinoBonusInactive": "Kampaniya hələ aktiv deyil",
  "socialMethods": "Sosial giriş",
  "orContinue": "və ya",
  "continueWithTelegram": "Telegram ilə davam et",
  "casinoBonus": "Kazino bonusu",
  "noRegistrationBonus": "Hazırda seçilə bilən qeydiyyat bonusu yoxdur.",
  "promoToggle": "Promo kod əlavə etmək",
  "promoPlaceholder": "Promo kod",
  "promoHint": "Kod qeydiyyat zamanı avtomatik tətbiq olunmur. Daxil olduqdan sonra Bonuslar səhifəsində yaza bilərsiniz.",
  "acceptTermsPrefix": "Mən ",
  "acceptTermsLink": "istifadə qaydalarını",
  "acceptTermsSuffix": " oxumuşam və razıyam.",
  "acceptTermsRequired": "Qeydiyyat üçün qaydalara razılıq lazımdır.",
  "termsMissingNote": "Qaydaların qaralama versiyası /qaydalar səhifəsindədir. Canlı nəşr üçün ayrıca təsdiq lazımdır. Qeydiyyat üçün xananı işarələyin.",
  "registerSubmit": "Qeydiyyatdan keçmək",
  "loginSubmit": "Daxil ol",
  "socialSoon": "Google və Telegram veb girişi hələ aktiv deyil.",
  "haveAccountPrompt": "Artıq hesabım var?",
  "haveAccountAction": "Daxil ol",
  "needAccountPrompt": "Hesab lazımdır?",
  "needAccountAction": "Qeydiyyat",
  "resetPassword": "Şifrəni sıfırlamaq",
  "closeDialog": "Bağla",
  "forgotLink": "Şifrəni unutmusunuz?",
  "forgotTitle": "Şifrəni bərpa et",
  "forgotIntro": "Hesabınızın e-poçtunu daxil edin. Qeydiyyatdadırsa, bərpa linki göndərəcəyik.",
  "forgotCta": "Bərpa linkini göndər",
  "forgotSent": "Bu e-poçtla hesab varsa, bərpa linki göndərildi. Gələnlər və spam qovluğunu yoxlayın.",
  "sendAgain": "Yenidən göndər",
  "emailDeliveryOff": "Bu serverdə e-poçt göndərişi hələ qurulmayıb, məktub gəlməyəcək.",
  "backToLogin": "Girişə qayıt",
  "resetTitle": "Yeni şifrə seçin",
  "newPassword": "Yeni şifrə",
  "confirmPassword": "Şifrəni təkrarlayın",
  "passwordsDontMatch": "Şifrələr uyğun gəlmir",
  "passwordRules": "Ən azı 8 simvol; hərflərlə yanaşı rəqəm və ya simvol olsun.",
  "resetCta": "Yeni şifrəni saxla",
  "resetDone": "Şifrə dəyişdirildi. Bütün sessiyalar bağlandı - yeni şifrə ilə daxil olun.",
  "linkInvalid": "Link etibarsızdır, vaxtı bitib və ya artıq istifadə olunub.",
  "requestNewLink": "Yeni link istə",
  "checking": "Yoxlanılır...",
  "verifyTitle": "E-poçtu təsdiqlə",
  "verifyIntro": "E-poçt ünvanınızı təsdiqləmək üçün düyməni basın.",
  "verifyCta": "E-poçtu təsdiqlə",
  "verifyDone": "E-poçt təsdiqləndi. Təşəkkür edirik!",
  "verifyResendHint": "Təhlükəsizlik səhifəsində yeni təsdiq məktubu istəyə bilərsiniz.",
  "securityTitle": "Hesab təhlükəsizliyi",
  "emailVerified": "Təsdiqlənib",
  "emailNotVerified": "Təsdiqlənməyib",
  "resendVerification": "Təsdiq məktubunu yenidən göndər",
  "verificationSent": "Təsdiq məktubu göndərildi.",
  "verificationSentAfterRegister": "Hesab yaradıldı. E-poçtunuza təsdiq linki göndərdik.",
  "phoneTitle": "Telefonla daxil ol",
  "phoneLinkTitle": "Telefon nömrəsi əlavə et",
  "phoneLabel": "Telefon nömrəsi",
  "phoneHint": "Azərbaycan nömrələrini 050 123 45 67 kimi yaza bilərsiniz. Digər ölkələr üçün + ilə başlayın.",
  "sendCode": "Kodu göndər",
  "codeLabel": "SMS-dəki kod",
  "codeSentTo": "{{phone}} nömrəsinə 6 rəqəmli kod göndərdik.",
  "verifyCode": "Təsdiqlə",
  "resendCode": "Kodu yenidən göndər",
  "resendIn": "{{seconds}} san. sonra yenidən göndər",
  "changeNumber": "Nömrəni dəyiş",
  "phoneLinked": "Telefon nömrəsi əlavə olundu.",
  "googleWorking": "Google ilə daxil olunur...",
  "googleLinked": "Google hesabı bağlandı.",
  "googleCancelled": "Google ilə giriş ləğv edildi.",
  "telegramWorking": "Telegram ilə daxil olunur...",
  "telegramCancelled": "Telegram ilə giriş ləğv edildi.",
  "signInToLink": "Hesabınıza daxil olun",
  "telegramWidgetUnavailable": "Telegram ilə veb-giriş botun domeni qurulduqdan sonra əlçatan olacaq. Telegram daxilində Mini App sizi avtomatik daxil edir.",
  "telegramLinked": "Telegram bağlandı.",
  "signInRequired": "Hesab təhlükəsizliyini idarə etmək üçün daxil olun.",
  "loginMethods": "Giriş üsulları",
  "methodPassword": "E-poçt və şifrə",
  "methodGoogle": "Google",
  "methodPhone": "Telefon (SMS)",
  "methodTelegram": "Telegram",
  "linked": "Bağlıdır",
  "notLinked": "Bağlı deyil",
  "link": "Bağla",
  "unlink": "Ayır",
  "unlinked": "Giriş üsulu silindi.",
  "lastMethodHint": "Yeganə giriş üsulunuzu silmək olmaz.",
  "unavailableProvider": "Qurulmayıb",
  "changePasswordTitle": "Şifrəni dəyiş",
  "setPasswordTitle": "Şifrə təyin et",
  "currentPassword": "Cari şifrə",
  "savePassword": "Şifrəni saxla",
  "passwordSaved": "Şifrə saxlanıldı. Digər sessiyalar bağlandı.",
  "changeEmailTitle": "E-poçtu dəyiş",
  "newEmail": "Yeni e-poçt",
  "saveEmail": "E-poçtu saxla",
  "emailSaved": "E-poçt yeniləndi. Yeni ünvanı gələn məktubdan təsdiqləyin.",
  "reauthTitle": "Bunun siz olduğunuzu təsdiqləyin",
  "reauthIntro": "Təhlükəsizlik üçün davam etməzdən əvvəl şifrənizi daxil edin.",
  "reauthPasswordless": "Təhlükəsizlik üçün davam etməzdən əvvəl yenidən daxil olun.",
  "reauthCta": "Davam et",
  "mfaCode": "Autentifikator kodu",
  "signInAgain": "Yenidən daxil ol",
  "sessionsTitle": "Sessiyalar",
  "logout": "Çıxış",
  "logoutAll": "Bütün cihazlardan çıx",
  "phoneNotSet": "Telefon nömrəsi yoxdur",
  "errors": {
    "invalid_credentials": "E-poçt və ya şifrə yanlışdır.",
    "too_many_requests": "Həddən çox cəhd. Bir az gözləyib yenidən cəhd edin.",
    "email_taken": "Bu e-poçt artıq qeydiyyatdadır. Daxil olun.",
    "password_too_short": "Şifrə çox qısadır (ən azı 8 simvol).",
    "password_too_long": "Şifrə çox uzundur (ən çox 128 simvol).",
    "password_too_weak": "Şifrə zəifdir. Hərflərlə yanaşı rəqəm və ya simvol istifadə edin.",
    "password_too_common": "Bu şifrə çox geniş yayılıb. Başqasını seçin.",
    "password_contains_email": "Şifrədə e-poçt adınız olmamalıdır.",
    "invalid_or_expired_token": "Link etibarsızdır, vaxtı bitib və ya artıq istifadə olunub.",
    "invalid_password": "Şifrə yanlışdır.",
    "invalid_email": "Düzgün e-poçt ünvanı daxil edin.",
    "email_not_set": "Hesabınızda e-poçt ünvanı yoxdur.",
    "reauth_required": "Davam etmək üçün bunun siz olduğunuzu təsdiqləyin.",
    "password_not_set": "Bu hesabda şifrə yoxdur. Bağlı üsulla yenidən daxil olun.",
    "email_required_for_password": "Şifrə təyin etməzdən əvvəl e-poçt ünvanı əlavə edin.",
    "email_delivery_unavailable": "E-poçt göndərişi hələ qurulmayıb.",
    "sms_disabled": "SMS ilə giriş hələ əlçatan deyil.",
    "phone_auth_disabled": "Telefonla qeydiyyat və SMS giriş müvəqqəti bağlıdır.",
    "sms_delivery_failed": "SMS göndərilə bilmədi. Sonra yenidən cəhd edin.",
    "invalid_phone": "Düzgün telefon nömrəsi daxil edin.",
    "resend_cooldown": "Yeni kod istəməzdən əvvəl bir az gözləyin.",
    "otp_invalid": "Kod yanlışdır və ya vaxtı bitib.",
    "otp_expired": "Kodun vaxtı bitib. Yenisini istəyin.",
    "otp_attempts_exceeded": "Çox sayda yanlış kod. Yeni kod istəyin.",
    "phone_in_use": "Bu telefon nömrəsi başqa hesaba aiddir.",
    "phone_signin_conflict_retry": "Yenidən cəhd edin.",
    "google_oauth_disabled": "Google ilə giriş hələ əlçatan deyil.",
    "telegram_oidc_disabled": "Telegram ilə veb-giriş hələ əlçatan deyil.",
    "google_account_exists_link_required": "Bu Google e-poçtu ilə hesab artıq var. Əvvəlcə ona daxil olun, sonra Təhlükəsizlik səhifəsində Google-u bağlayın.",
    "google_linked_to_other_account": "Bu Google hesabı başqa VBB PLAY hesabına bağlıdır.",
    "google_other_account_linked": "Artıq başqa Google hesabı bağlıdır. Əvvəlcə onu ayırın.",
    "google_signin_conflict_retry": "Yenidən cəhd edin.",
    "invalid_state": "Giriş cəhdinin vaxtı bitib və ya başqa brauzerdə başlanıb. Yenidən cəhd edin.",
    "state_expired": "Giriş cəhdinin vaxtı bitib. Yenidən cəhd edin.",
    "nonce_mismatch": "Sosial giriş yoxlanıla bilmədi. Yenidən cəhd edin.",
    "invalid_id_token": "Sosial giriş yoxlanıla bilmədi. Yenidən cəhd edin.",
    "token_exchange_failed": "Sosial giriş təsdiqlənmədi. Yenidən cəhd edin.",
    "signing_key_unavailable": "Sosial giriş müvəqqəti əlçatan deyil. Yenidən cəhd edin.",
    "link_session_mismatch": "Bağlamanı başladan eyni hesaba daxil olun.",
    "telegram_already_linked": "Bu Telegram hesabı başqa VBB PLAY hesabına bağlıdır.",
    "telegram_other_account_linked": "Artıq başqa Telegram hesabı bağlıdır. Əvvəlcə onu ayırın.",
    "telegram_payload_required": "Telegram giriş məlumatlarını qaytarmadı.",
    "auth_data_replayed": "Bu Telegram girişi artıq istifadə olunub. Yenidən daxil olun.",
    "auth_data_expired": "Telegram girişinin vaxtı bitib. Yenidən cəhd edin.",
    "invalid_hash": "Telegram girişi yoxlanıla bilmədi.",
    "last_login_method": "Yeganə giriş üsulunuzu silmək olmaz.",
    "account_suspended": "Bu hesab dayandırılıb. Dəstəyə müraciət edin.",
    "admin_email_change_disabled": "Administrator e-poçtunu yalnız operator dəyişə bilər.",
    "mfa_required": "Autentifikator tətbiqindəki kodu daxil edin."
  }
}
